import React from 'react'
import styled from 'styled-components'
import { getThemeStyle } from '../../utilities/helpers'
import ImportanceHearts from './importance-hearts'
import StatementStatBarSm from './statement-stat-bar-sm'
import DriverStatBarSm from './driver-stat-bar-sm'
import { TABLET } from '../../utilities/breakpoints'
import { isNullOrUndefined } from '../../utilities/helpers'
import RespondentGroups from './respondent-groups'

const CompactStatRow = ({
  index,
  surveyThemeIndex,
  title,
  result,
  rate,
  respondentGroups,
  type = "statement",
  showLabels = false,
  showNumbers = true,
  showTitleLabel = false,
  useTranslate
}) => {

  return (
    <Statement className="compact-stat-row">
      {showLabels &&
        <LabelsRow>
          <LabelColumns>
            <TitleColumn>
              {showTitleLabel &&
                <Label className="label">
                  {type === 'statement' ? useTranslate('data_vault.label_statement') : useTranslate('data_vault.label_driver')}
                </Label>
              }
            </TitleColumn>
            <CurrentStateColumn>
              <Label className="label">{useTranslate('data_vault.current_state')}</Label>
            </CurrentStateColumn>
            <ImportanceColumn>
              <Label className="label">{useTranslate('data_vault.importance')}</Label>
            </ImportanceColumn>
          </LabelColumns>
        </LabelsRow>
      }
      <ResultsRow>
        <Title>
          {!isNullOrUndefined(surveyThemeIndex) &&
            <Index style={{backgroundColor: getThemeStyle(surveyThemeIndex).bgColor}}>{showNumbers ? index : ''}</Index>
          }
          <TitleContent>
            <h5>{title}</h5>
            {respondentGroups && <RespondentGroups items={respondentGroups} size="small" useTranslate={useTranslate} />}
          </TitleContent>
        </Title>
        <Results>
          <CurrentStateColumn>
            <Label className="label">{useTranslate('data_vault.current_state')}</Label>
            <div className="result-container">
              {type === "statement" ?
                <StatementStatBarSm result={result} />
                :
                <DriverStatBarSm result={result} />
              }
              <span className="result">{result !== null ? `${result.toFixed(0)}%` : "-"}</span>
            </div>
          </CurrentStateColumn>
          <ImportanceColumn>
            <Label className="label">{useTranslate('data_vault.importance')}</Label>
            <div className="result-container">
              <ImportanceHearts importance={rate} />
              <span className="result">{rate ? `${rate.toFixed(1)}` : "-"}</span>
            </div>
          </ImportanceColumn>
        </Results>
      </ResultsRow>
    </Statement>
  )
}

export default CompactStatRow;

const Statement = styled.div`
  width: 100%;
  padding: 0 0 12px;
  
  + .compact-stat-row {
    border-top: 1px solid #E4E7EB;
    padding: 12px 0 12px;
  }
`;

const ResultsRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  
  @media${TABLET} {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }
`;

const LabelsRow = styled.div`
  width: 100%;
  display: none;
  
  @media${TABLET} {
    display: flex;
    justify-content: space-between;
  }
`;

const LabelColumns = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
 `;

const Label = styled.span`
  display: block;
  font-size: 13px;
  color: #656579;
  font-weight: 500;
  margin-bottom: 8px;
`;

const Title = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  @media${TABLET} {
    margin-bottom: 0;
  }
`;

const TitleContent = styled.div`
  display: flex;
  flex-direction: column;

  h5 {
    font-size: 1rem;
    font-weight: 500;
    margin: 0;
  }

  > * {
    margin-left: 0;
  }

  > div {
    margin-top: 4px;
  }
`;

const Index = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 100%;
  display: flex;
  flex: 0 0 20px;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 600;
  font-size: 13px;
  margin-right: 8px;
`;

const Results = styled.div`
  display: flex;
  align-items: center;
  padding-left: 0;
  width: 100%;
  
  .result-container {
    display: flex;
    align-items: center;
  }
  
  .result {
    display: block;
    font-size: 14px;
    line-height: 1.3;
    font-weight: 500; 
    margin-left: 10px;
    width: 40px;
  }
  
  @media${TABLET} {
    width: auto;
    
    ${Label} {
      display: none;
    }
  }
`;

const TitleColumn = styled.div`
  display: none;

  @media${TABLET} {
    display: block;
    width: auto;
    margin-right: auto;
  }
`;

const CurrentStateColumn = styled.div`
  width: 140px;

  @media${TABLET} {
    width: 160px;
  }
`;

const ImportanceColumn = styled.div`
  width: 140px;

  @media${TABLET} {
    width: 160px;
  }
`;


// WEBPACK FOOTER //
// ./src/components/ui/compact-stat-row.js